import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/** The way out for anyone with no payroll row: their payroll is generated in the Payroll Table, not here. */
export const PayrollTableLink: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Link to="/payroll/table" className="inline-flex items-center gap-1 font-medium text-primary hover:underline">
      {t('payroll.complianceCenter.ksaWps.goToPayrollTable', 'Go to Payroll Table')}
      <ArrowRight className="w-3 h-3 rtl:rotate-180" aria-hidden="true" />
    </Link>
  );
};
